import { ENTITLEMENTS, type Entitlement } from '../platform/access/entitlements'

/**
 * RevenueCat's entitlement id for the paid plan — the SAME id iOS uses
 * (`PremiumProductIdentifier.premiumEntitlement`, `Premium.swift`; PRD
 * `00-product-overview.md` §3).
 *
 * TODO(billing): placeholder-for-now. iOS has ONE RevenueCat entitlement and
 * its own comment says it "grants access to all premium features"; the seven
 * app entitlements are not separate RevenueCat entitlements. Update this when
 * the Web Billing app is created and the ids are settled (PRD M13 Q3).
 */
export const REVENUECAT_PRO_ENTITLEMENT = 'TrackE5_Pro'

/**
 * Active RevenueCat entitlement ids → the app's seven. Holding the pro
 * entitlement grants all seven; any other id grants nothing (unknowns dropped,
 * as `EntitlementsProvider` does). Per-user only: nothing household-wide.
 */
export function grantedFromActive(activeIds: readonly string[]): readonly Entitlement[] {
  return activeIds.includes(REVENUECAT_PRO_ENTITLEMENT) ? ENTITLEMENTS : []
}
